import { Helmet } from "react-helmet";

export default function TermsOfService() {
  return (
    <section className="my-20">
      <Helmet>
        <title>Dailysocialboost | Terms of use</title>
      </Helmet>
      <h2 className="text-center text-5xl font-bold my-10">Terms and Conditions</h2>
      <h4 className="font-semibold">Terms of Use</h4>
      <p className="my-5">
        Thank you for choosing our services (“Services”). By accessing and using our website, you
        agree to comply with and be bound by the following Terms and Conditions of Use. This
        Agreement forms a legally binding contract between you (“User”, “you”, or “you are”) and us
        (“[Your Company Name]”, “we”, “us”, or “our”). If you disagree with any part of these terms,
        please do not use our website. The materials on our website are protected by applicable
        copyright and trademark laws.
      </p>

      <h4 className="font-semibold">Use License</h4>
      <p className="my-5">
        You are granted permission to temporarily download one copy of the materials on our website
        for personal, non-commercial transitory viewing only. This is a grant of a license, not a
        transfer of title. Under this license, you may not modify, copy, use for commercial
        purposes, publicly display, attempt to decompile or reverse engineer any software, remove
        any copyright notations, or transfer the materials to another person or server. This license
        will automatically terminate if you violate any of these restrictions and may be terminated
        by [Your Company Name] at any time. Upon termination, you must destroy any downloaded
        materials in your possession
      </p>

      <h4 className="font-semibold">Disclaimer</h4>
      <p className="my-5">
        The materials on our website are provided “as is”. We make no warranties and hereby disclaim
        all other warranties, including implied warranties or conditions of merchantability, fitness
        for a particular purpose, or non-infringement of intellectual property. We do not warrant
        the accuracy, likely results, or reliability of the use of materials on our website or
        otherwise relating to such materials or on any linked sites. Limitations In no event shall
        we or our suppliers be liable for any damages arising out of the use or inability to use the
        materials on our website, even if notified orally or in writing of the possibility of such
        damage.
      </p>

      <h4 className="font-semibold">Revisions and Errata</h4>
      <p className="my-5">
        The materials on our website could include errors. We do not warrant that any of the
        materials are accurate, complete, or current and may change the materials at any time
        without notice.
      </p>

      <h4 className="font-semibold">Links</h4>
      <p className="my-5">
        We have not reviewed all the sites linked to our website and are not responsible for the
        contents of any linked site. The inclusion of any link does not imply endorsement. Use of
        any linked website is at the user’s own risk.{" "}
      </p>

      <h4 className="font-semibold">Site Terms of Use Modifications</h4>
      <p className="my-5">
        We may revise these terms at any time without notice. By using our website, you agree to the
        current version of these Terms and Conditions.{" "}
      </p>

      <h4 className="font-semibold">Governing Law</h4>
      <p className="my-5">
        Any claim relating to our website shall be governed by the laws of the jurisdiction of [Your
        Company Name] without regard to its conflict of law provisions
      </p>

      <h4 className="font-semibold">Support</h4>
      <p className="my-5">
        We offer industry-leading support for any sales or technical questions via our support team
        or contact form.{" "}
      </p>
      <h4 className="font-semibold">Refunds</h4>
      <p className="my-5">
        Unsatisfied customers may request a full refund within the first 30 days of purchase.
        Refunds are processed through our support agents and do not apply to free credits or
        services.{" "}
      </p>
      <h4 className="font-semibold">Service</h4>
      <p className="my-5">
        We are not affiliated with any Social Media platforms. You are responsible for complying
        with social media rules and legislation. We are not liable for your actions or any account
        bans. The expected number of followers, likes, and views is not guaranteed. We cannot
        guarantee continuous, uninterrupted, or error-free service. It is your responsibility to
        ensure your accounts are set to “public” during our service. We are not liable for service
        downtime due to profile privacy changes. You agree not to file a fraudulent dispute for
        purchases. We reserve the right to modify or withdraw our service at any time without
        notice.
      </p>
      <h4 className="font-semibold">Contact</h4>
      <p className="my-5">Reach us through our contact form. Our team responds within 24 hours.</p>
    </section>
  );
}
